import {type ImmutableArray} from 'web-app/util/types/immutable';

export const roundToDecimals = (num: number, precision: number) => {
    const factor = Math.pow(10, precision);
    const tempNumber = num * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
};

export const findNearestNumber = (target: number, numbers: number[]): number =>
    numbers.reduce((prev, curr) => {
        return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev;
    });

/**
 * Sums all the values in the 'amount' key of multiple objects.
 * @param items: Array of objects that contain the key 'amount'
 */
export function calculateTotalAmount<T extends {amount: number}>(items: ImmutableArray<Pick<T, 'amount'>>): number {
    return (
        Math.round(
            items.reduce((curr: number, item) => {
                const amount = item.amount;
                curr += amount * 100;
                return curr;
            }, 0),
        ) / 100
    );
}

/**
 * Sums all the values in the 'amount' key of multiple objects
 * and checks if 'type' is invoice or payment to add amount as positive or negative value.
 * @param items: Array of objects of 'type' invoice or payment which contain the key 'amount'
 */
export function calculateTotalAmountOfPaymentsAndInvoices<T extends {amount: number; type: string}>(
    items: ImmutableArray<Pick<T, 'amount' | 'type'>>,
): number {
    return (
        Math.round(
            items.reduce((curr: number, item) => {
                const amount = item.type === 'invoice' ? -item.amount : item.amount;
                curr += amount * 100;
                return curr;
            }, 0),
        ) / 100
    );
}
